export const NOW_NOT_ELIGIBLE_REASON_MINIMUM_VALUE_NOT_REACHED = 40
export const NOW_NOT_ELIGIBLE_REASON_NOT_IN_DELIVERY_REGION = 10
export const NOW_NOT_ELIGIBLE_REASON_PRODUCTS_NOT_AVAILABLE = 20
export const NOW_NOT_ELIGIBLE_REASON_NO_AVAILABLE_SLOT = 30
export const NOW_NOT_ELIGIBLE_REASON_NO_AVAILABLE_SLOT_QS = 22
export const NOW_NOT_ELIGIBLE_REASON_RX_NOT_AVAILABLE = 999
